import React, { useState } from 'react';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip
} from '@mui/material';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import { useTranslation } from 'react-i18next';

const WidgetTabMoveMenu = ({
  tabs = [],
  currentTabId,
  onMove,
  disabled = false,
  buttonSx = {}
}) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <Tooltip title={t('dashboard.tabs_move_widget', 'Move widget to tab')}>
        <span>
          <IconButton
            size="small"
            disabled={disabled}
            aria-label={t('dashboard.tabs_move_widget', 'Move widget to tab')}
            onMouseDown={(event) => event.stopPropagation()}
            onTouchStart={(event) => event.stopPropagation()}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{
              width: 32,
              height: 32,
              color: '#5757b0',
              backgroundColor: 'rgba(87, 87, 176, 0.1)',
              border: '1px solid rgba(87, 87, 176, 0.2)',
              '&:hover': { backgroundColor: 'rgba(87, 87, 176, 0.2)' },
              ...buttonSx
            }}
          >
            <DriveFileMoveOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        PaperProps={{ 'data-widget-menu': 'tab-move' }}
        MenuListProps={{
          'aria-label': t('dashboard.tabs_move_widget', 'Move widget to tab'),
          onMouseDown: (event) => event.stopPropagation(),
          onTouchStart: (event) => event.stopPropagation()
        }}
      >
        {tabs.map((tab) => (
          <MenuItem
            key={tab.id}
            selected={tab.id === currentTabId}
            disabled={tab.id === currentTabId}
            onMouseDown={(event) => event.stopPropagation()}
            onTouchStart={(event) => event.stopPropagation()}
            onClick={(event) => {
              event.stopPropagation();
              onMove?.(tab.id);
              closeMenu();
            }}
          >
            <ListItemIcon>
              <DriveFileMoveOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={tab.name} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default WidgetTabMoveMenu;
